var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { PageLimit, Icon, IconButton, theme, QRCode, Dialog, ActionsContainer, StyledButton, } from "@sequentech/ui-essentials";
import { stringToHtml, EVotingStatus, EElectionEventContestEncryptionPolicy, } from "@sequentech/ui-core";
import { styled } from "@mui/material/styles";
import { faPrint, faCircleQuestion, faCheck } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Link from "@mui/material/Link";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { selectAuditableBallot } from "../store/auditableBallots/auditableBallotsSlice";
import { canVoteSomeElection } from "../store/castVotes/castVotesSlice";
import { selectElectionEventById } from "../store/electionEvents/electionEventsSlice";
import { clearBallot } from "../store/ballotSelections/ballotSelectionsSlice";
import { selectBallotStyleByElectionId, selectBallotStyleElectionIds, selectFirstBallotStyle, } from "../store/ballotStyles/ballotStylesSlice";
import { AuthContext } from "../providers/AuthContextProvider";
import { useMutation, useQuery } from "@apollo/client/react";
import { CREATE_BALLOT_RECEIPT } from "../queries/CreateBallotReceipt";
import { useGetPublicDocumentUrl } from "../hooks/public-document-url";
import Stepper from "../components/Stepper";
import { SettingsContext } from "../providers/SettingsContextProvider";
import { provideBallotService } from "../services/BallotService";
import { VotingPortalError, VotingPortalErrorType } from "../services/VotingPortalError";
import { GET_ELECTIONS } from "../queries/GetElections";
import { downloadUrl } from "@sequentech/ui-core";
import { selectConfirmationScreenData, } from "../store/castVotes/confirmationScreenDataSlice";
import { GET_CAST_VOTES } from "../queries/GetCastVotes";
import { GET_DOCUMENT } from "../queries/GetDocument";
var StyledTitle = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n"], ["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n"])));
var BallotIdContainer = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    gap: 30px;\n    margin: 25px 0;\n    align-items: center;\n"], ["\n    display: flex;\n    flex-direction: row;\n    gap: 30px;\n    margin: 25px 0;\n    align-items: center;\n"])));
var BallotIdBorder = styled(Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n    padding: 10px 12px;\n    display: flex;\n    flex-direction: row;\n    justify-content: left;\n    align-items: center;\n    gap: 10px;\n    border-radius: 4px;\n"], ["\n    background-color: ", ";\n    color: ", ";\n    padding: 10px 12px;\n    display: flex;\n    flex-direction: row;\n    justify-content: left;\n    align-items: center;\n    gap: 10px;\n    border-radius: 4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.green.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.customGrey.contrastText;
});
var BallotIdLink = styled(Link)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    text-decoration: none;\n    font-weight: normal;\n    overflow-wrap: anywhere;\n    text-overflow: ellipsis;\n    &:hover {\n        text-decoration: underline;\n    }\n"], ["\n    color: ", ";\n    text-decoration: none;\n    font-weight: normal;\n    overflow-wrap: anywhere;\n    text-overflow: ellipsis;\n    &:hover {\n        text-decoration: underline;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.brandColor;
});
var QRContainer = styled(Box)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    margin: 15px auto;\n"], ["\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    margin: 15px auto;\n"])));
var StyledCircularProgress = styled(CircularProgress)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 14px !important;\n    height: 14px !important;\n"], ["\n    width: 14px !important;\n    height: 14px !important;\n"])));
var StyledIcon = styled(Icon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    min-width: 14px;\n    padding: 5px;\n"], ["\n    min-width: 14px;\n    padding: 5px;\n"])));
var ActionButtons = function (_a) {
    var _b, _c, _d;
    var ballotTrackerUrl = _a.ballotTrackerUrl, electionId = _a.electionId, ballotId = _a.ballotId, isGoldenAuth = _a.isGoldenAuth;
    var logout = useContext(AuthContext).logout;
    var t = useTranslation().t;
    var _e = useParams(), tenantId = _e.tenantId, eventId = _e.eventId;
    var canVote = useAppSelector(canVoteSomeElection());
    var navigate = useNavigate();
    var location = useLocation();
    var ballotStyle = useAppSelector(selectBallotStyleByElectionId(String(electionId)));
    var dispatch = useAppDispatch();
    var electionEvent = useAppSelector(selectElectionEventById(eventId));
    var createBallotReceipt = useMutation(CREATE_BALLOT_RECEIPT)[0];
    var _f = useState(null), documentId = _f[0], setDocumentId = _f[1];
    var getDocumentUrl = useGetPublicDocumentUrl().getDocumentUrl;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _g = useState(false), errorDialog = _g[0], setErrorDialog = _g[1];
    var _h = useState(false), openPrintDemoModal = _h[0], setOpenPrintDemoModal = _h[1];
    var oneBallotStyle = useAppSelector(selectFirstBallotStyle);
    var isDemo = (_b = oneBallotStyle === null || oneBallotStyle === void 0 ? void 0 : oneBallotStyle.ballot_eml.public_key) === null || _b === void 0 ? void 0 : _b.is_demo;
    var _j = useState(false), isPolling = _j[0], setIsPolling = _j[1];
    var presentation = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation;
    var ballotStyleElectionIds = useAppSelector(selectBallotStyleElectionIds);
    var dataElections = useQuery(GET_ELECTIONS, {
        variables: {
            electionIds: (ballotStyleElectionIds === null || ballotStyleElectionIds === void 0 ? void 0 : ballotStyleElectionIds.length) ? ballotStyleElectionIds : [electionId],
        },
        skip: globalSettings.DISABLE_AUTH, // Skip query if in demo mode
    }).data;
    var _k = useQuery(GET_DOCUMENT, {
        variables: {
            ids: documentId ? [documentId] : [],
            electionEventId: eventId,
            tenantId: tenantId || "",
        },
        skip: !documentId, // Skip query if no documentId
    }), ballotReceiptDocuments = _k.data, startPolling = _k.startPolling, stopPolling = _k.stopPolling;
    var isAnyVotingStatusOpen = dataElections === null || dataElections === void 0 ? void 0 : dataElections.sequent_backend_election.some(function (item) { return item.status.voting_status === EVotingStatus.OPEN; });
    var _l = useQuery(GET_CAST_VOTES, {
        skip: globalSettings.DISABLE_AUTH || !isGoldenAuth,
    }), castVotes = _l.data, errorCastVote = _l.error;
    function isAllowedToCastVote() {
        var _a, _b;
        if (isGoldenAuth) {
            // Can´t use canVote when isGoldenAuth because the state in redux was removed at logout.
            var election = dataElections === null || dataElections === void 0 ? void 0 : dataElections.sequent_backend_election.filter(function (item) { return item.id === electionId; })[0];
            var numAllowedRevotes = (_a = election === null || election === void 0 ? void 0 : election.num_allowed_revotes) !== null && _a !== void 0 ? _a : 1;
            var electionCastVotes = (_b = castVotes === null || castVotes === void 0 ? void 0 : castVotes.sequent_backend_cast_vote.filter(function (castVote) { return castVote.election_id === electionId; })) !== null && _b !== void 0 ? _b : [];
            console.log(numAllowedRevotes, electionCastVotes, election === null || election === void 0 ? void 0 : election.id, electionId, castVotes);
            if (numAllowedRevotes === 0) {
                return true;
            }
            return electionCastVotes.length < numAllowedRevotes;
        }
        else {
            return canVote;
        }
    }
    var onClickFinishButton = useCallback(function () {
        var _a;
        console.log("isGoldenAuth: ", isGoldenAuth);
        console.log("onClickFinishButton", isAnyVotingStatusOpen, isAllowedToCastVote(), canVote, globalSettings.DISABLE_AUTH);
        if ((isAnyVotingStatusOpen && isAllowedToCastVote()) || globalSettings.DISABLE_AUTH) {
            navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election-chooser").concat(location.search));
        }
        else {
            logout((_a = presentation === null || presentation === void 0 ? void 0 : presentation.redirect_finish_url) !== null && _a !== void 0 ? _a : undefined);
        }
    }, [isAnyVotingStatusOpen, canVote]);
    useEffect(function () {
        if (ballotStyle) {
            dispatch(clearBallot());
        }
    }, [ballotStyle, dispatch]);
    var _m = useState(false), isDownloadingReport = _m[0], setIsDownloadingReport = _m[1];
    var _o = useState(false), isHitPrint = _o[0], setIsHitPrint = _o[1];
    var maxRetries = 5;
    var retryInterval = globalSettings.QUERY_POLL_INTERVAL_MS;
    function printBallotReceiptReport() {
        return __awaiter(this, void 0, void 0, function () {
            var res, docId;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setIsHitPrint(true);
                        if (isDemo) {
                            setOpenPrintDemoModal(true);
                            return [2 /*return*/];
                        }
                        if (!!documentId) return [3 /*break*/, 2];
                        return [4 /*yield*/, createBallotReceipt({
                                variables: {
                                    ballot_id: ballotId,
                                    ballot_tracker_url: ballotTrackerUrl,
                                    election_event_id: eventId,
                                    tenant_id: tenantId,
                                    election_id: electionId,
                                },
                            })];
                    case 1:
                        res = _c.sent();
                        docId = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.create_ballot_receipt) === null || _b === void 0 ? void 0 : _b.id;
                        console.log("docId: ", docId);
                        setDocumentId(docId);
                        _c.label = 2;
                    case 2:
                        setIsDownloadingReport(true);
                        return [2 /*return*/];
                }
            });
        });
    }
    function downloadFileWithRetry(url_1, name_1) {
        return __awaiter(this, arguments, void 0, function (url, name, retries) {
            var error_1;
            if (retries === void 0) { retries = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, downloadUrl(url, name)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Error downloading file:", error_1);
                        if (retries < maxRetries) {
                            setTimeout(function () {
                                downloadFileWithRetry(url, name, retries + 1);
                            }, retryInterval);
                        }
                        else {
                            console.error("Failed to download file after", maxRetries, "retries");
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        var _a, _b;
        if (((_b = (_a = ballotReceiptDocuments === null || ballotReceiptDocuments === void 0 ? void 0 : ballotReceiptDocuments.sequent_backend_document) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id) && documentId) {
            var fileName = "ballot_receipt_".concat(eventId, ".pdf");
            var documentUrl = getDocumentUrl(documentId, fileName);
            downloadFileWithRetry(documentUrl, fileName);
            setIsDownloadingReport(false);
            setIsHitPrint(false);
            setIsPolling(false);
            setDocumentId(null);
            stopPolling();
        }
    }, [(_d = (_c = ballotReceiptDocuments === null || ballotReceiptDocuments === void 0 ? void 0 : ballotReceiptDocuments.sequent_backend_document) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.id, documentId]);
    useEffect(function () {
        if (!isPolling && documentId) {
            setIsPolling(true);
            startPolling(globalSettings.QUERY_POLL_INTERVAL_MS);
        }
    }, [startPolling, globalSettings.QUERY_POLL_INTERVAL_MS, documentId, isPolling]);
    return (_jsxs(_Fragment, { children: [_jsxs(ActionsContainer, { children: [_jsxs(StyledButton, { onClick: printBallotReceiptReport, disabled: isHitPrint, variant: "secondary", sx: { margin: "auto 0", width: { xs: "100%", sm: "200px" } }, children: [isHitPrint ? (_jsx(StyledCircularProgress, { color: "inherit" })) : (_jsx(StyledIcon, { icon: faPrint, size: "sm" })), _jsx(Box, { children: t("confirmationScreen.printButton") })] }), _jsx(StyledButton, { className: "finish-button", onClick: onClickFinishButton, sx: { width: { xs: "100%", sm: "200px" } }, children: _jsx(Box, { children: t("confirmationScreen.finishButton") }) })] }), _jsx(Dialog, { handleClose: function () { return setOpenPrintDemoModal(false); }, open: openPrintDemoModal, title: t("confirmationScreen.demoPrintDialog.title"), ok: t("confirmationScreen.demoPrintDialog.ok"), variant: "info", children: stringToHtml(t("confirmationScreen.demoPrintDialog.content")) }), _jsx(Dialog, { handleClose: function () { return setErrorDialog(false); }, open: errorDialog, title: t("confirmationScreen.errorDialogPrintBallotReceipt.title"), ok: t("confirmationScreen.errorDialogPrintBallotReceipt.ok"), variant: "warning", children: stringToHtml(t("confirmationScreen.errorDialogPrintBallotReceipt.content")) })] }));
};
var ConfirmationScreen = function () {
    var _a;
    var _b = useParams(), tenantId = _b.tenantId, eventId = _b.eventId;
    var electionId = useParams().electionId;
    var auditableBallot = useAppSelector(selectAuditableBallot(String(electionId)));
    var confirmationScreenData = useAppSelector(selectConfirmationScreenData(String(electionId)));
    var t = useTranslation().t;
    var _c = useState(false), openBallotIdHelp = _c[0], setOpenBallotIdHelp = _c[1];
    var _d = useState(false), openConfirmationHelp = _d[0], setOpenConfirmationHelp = _d[1];
    var _e = useState(false), openDemoBallotUrlHelp = _e[0], setDemoBallotUrlHelp = _e[1];
    var _f = provideBallotService(), hashBallot = _f.hashBallot, hashMultiBallot = _f.hashMultiBallot;
    var oneBallotStyle = useAppSelector(selectFirstBallotStyle);
    var getBallotId = function () {
        var _a, _b;
        if (!auditableBallot) {
            if (!confirmationScreenData) {
                console.log("confirmationScreenData not found in redux");
                return { ballotIdStored: undefined, isDemoStored: undefined };
            }
            else {
                return {
                    ballotIdStored: confirmationScreenData.ballotId,
                    isDemoStored: confirmationScreenData.isDemo,
                };
            }
        }
        else {
            console.log("auditableBallot normal flow");
            var isMultiContest = ((_a = auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.config.election_event_presentation) === null || _a === void 0 ? void 0 : _a.contest_encryption_policy) ==
                EElectionEventContestEncryptionPolicy.MULTIPLE_CONTESTS;
            var hashableBallot = isMultiContest
                ? hashMultiBallot(auditableBallot)
                : hashBallot(auditableBallot);
            var ballotIdStored = (auditableBallot && hashableBallot) || undefined;
            var isDemoStored = (_b = oneBallotStyle === null || oneBallotStyle === void 0 ? void 0 : oneBallotStyle.ballot_eml.public_key) === null || _b === void 0 ? void 0 : _b.is_demo;
            return { ballotIdStored: ballotIdStored, isDemoStored: isDemoStored };
        }
    };
    var ballotId = useRef(undefined);
    var gotData = useRef(false);
    var navigate = useNavigate();
    var _g = useState(false), demoBallotIdHelp = _g[0], setDemoBallotIdHelp = _g[1];
    var _h = useState(false), isDemo = _h[0], setIsDemo = _h[1];
    var _j = useState(undefined), ballotTrackerUrl = _j[0], setBallotTrackerUrl = _j[1];
    if (gotData.current &&
        (auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.ballot_hash) &&
        ballotId.current !== (auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.ballot_hash)) {
        console.log("ballotId: ".concat(ballotId.current, "\n auditable Ballot Hash: ").concat(auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.ballot_hash));
        throw new VotingPortalError(VotingPortalErrorType.INCONSISTENT_HASH);
    }
    useEffect(function () {
        if (!gotData.current) {
            gotData.current = true;
            var _a = getBallotId(), ballotIdStored = _a.ballotIdStored, isDemoStored = _a.isDemoStored;
            if (!ballotIdStored) {
                console.log("No stored ballot found, navigating to the election-chooser page.");
                navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election-chooser"));
            }
            ballotId.current = ballotIdStored;
            setIsDemo(isDemoStored !== null && isDemoStored !== void 0 ? isDemoStored : false);
            setBallotTrackerUrl("".concat(window.location.protocol, "//").concat(window.location.host, "/tenant/").concat(tenantId, "/event/").concat(eventId, "/election/").concat(electionId, "/ballot-locator/").concat(ballotIdStored));
        }
    }, []);
    var handleBallotIdLinkClick = function (event) {
        if (isDemo) {
            event.preventDefault();
            setDemoBallotUrlHelp(true);
        }
    };
    return (_jsxs(PageLimit, { maxWidth: "lg", className: "confirmation-screen screen", children: [_jsx(Box, { marginTop: "24px", children: _jsx(Stepper, { selected: 3 }) }), _jsxs(StyledTitle, { variant: "h4", fontSize: "24px", fontWeight: "bold", sx: { marginTop: "40px" }, children: [_jsx(Box, { children: t("confirmationScreen.title") }), _jsx(IconButton, { icon: faCircleQuestion, sx: { fontSize: "unset", lineHeight: "unset", paddingBottom: "2px" }, fontSize: "16px", onClick: function () { return setOpenConfirmationHelp(true); } }), _jsx(Dialog, { handleClose: function () { return setOpenConfirmationHelp(false); }, open: openConfirmationHelp, title: t("confirmationScreen.confirmationHelpDialog.title"), ok: t("confirmationScreen.confirmationHelpDialog.ok"), variant: "info", children: stringToHtml(t("confirmationScreen.confirmationHelpDialog.content")) })] }), _jsx(Typography, { variant: "body2", sx: { color: theme.palette.customGrey.main }, children: stringToHtml(t("confirmationScreen.description")) }), _jsxs(BallotIdContainer, { children: [_jsx(Typography, { variant: "h5", fontSize: "18px", fontWeight: "bold", sx: { display: { xs: "none", sm: "block" } }, children: t("confirmationScreen.ballotId") }), _jsxs(BallotIdBorder, { children: [_jsx(IconButton, { icon: faCheck, sx: { fontSize: "unset", lineHeight: "unset", paddingBottom: "2px" }, fontSize: "14px", color: theme.palette.customGrey.contrastText }), _jsx(BallotIdLink, { href: !isDemo ? ballotTrackerUrl : undefined, target: !isDemo ? "_blank" : undefined, sx: { display: { xs: "none", sm: "block" } }, onClick: handleBallotIdLinkClick, children: ballotId.current }), _jsx(BallotIdLink, { href: !isDemo ? ballotTrackerUrl : undefined, target: !isDemo ? "_blank" : undefined, sx: { display: { xs: "block", sm: "none" } }, onClick: handleBallotIdLinkClick, children: t("ballotHash", { ballotId: ballotId.current }) }), _jsx(IconButton, { icon: faCircleQuestion, sx: {
                                    fontSize: "unset",
                                    lineHeight: "unset",
                                    marginLeft: "16px",
                                }, fontSize: "18px", onClick: function () {
                                    return isDemo ? setDemoBallotIdHelp(true) : setOpenBallotIdHelp(true);
                                } }), _jsx(Dialog, { handleClose: function () { return setOpenBallotIdHelp(false); }, open: openBallotIdHelp, title: t("confirmationScreen.ballotIdHelpDialog.title"), ok: t("confirmationScreen.ballotIdHelpDialog.ok"), variant: "info", children: stringToHtml(t("confirmationScreen.ballotIdHelpDialog.content")) }), _jsx(Dialog, { handleClose: function () { return setDemoBallotUrlHelp(false); }, open: openDemoBallotUrlHelp, title: t("confirmationScreen.demoBallotUrlDialog.title"), ok: t("confirmationScreen.demoBallotUrlDialog.ok"), variant: "info", children: stringToHtml(t("confirmationScreen.demoBallotUrlDialog.content")) }), _jsx(Dialog, { handleClose: function () { return setDemoBallotIdHelp(false); }, open: demoBallotIdHelp, title: t("confirmationScreen.ballotIdDemoHelpDialog.title"), ok: t("confirmationScreen.ballotIdDemoHelpDialog.ok"), variant: "info", children: stringToHtml(t("confirmationScreen.ballotIdDemoHelpDialog.content")) })] })] }), _jsx(Typography, { variant: "h5", fontSize: "18px", fontWeight: "bold", children: t("confirmationScreen.verifyCastTitle") }), _jsx(Typography, { variant: "body2", sx: { color: theme.palette.customGrey.main }, id: "qr-code-description", children: stringToHtml(t("confirmationScreen.verifyCastDescription")) }), _jsx(QRContainer, { className: "qr-container", children: _jsx(QRCode, { ariaLabelledby: "qr-code-description", value: isDemo ? t("confirmationScreen.demoQRText") : (ballotTrackerUrl !== null && ballotTrackerUrl !== void 0 ? ballotTrackerUrl : "") }) }), _jsx(ActionButtons, { ballotTrackerUrl: ballotTrackerUrl, electionId: electionId, ballotId: (_a = ballotId.current) !== null && _a !== void 0 ? _a : "", isGoldenAuth: confirmationScreenData ? true : false })] }));
};
export default ConfirmationScreen;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
